<template>
    <TItems
        :footer-button="footerButtonTheme"
        :active-buttons="activeIndexButtons"
        :footer-button-text="footerButtonText"
        :current-letter-index-panel="currentLetterIndexPanel"
        class="o-d-care d-care"
        index-panel
        @clickFooterButton="handleFooterClick"
        @clickLetter="handleLetterClick"
    >
        <template #header>
            <OWItemsHeader
                color="#157251"
                :title="$t('ui.care-category')"
                :subtitle="$t('ui.care-category.description')"
            >
                <template #left>
                    <svg-icon
                        original
                        name="icons/care-green"
                        class="d-care__header-icon"
                    />
                </template>
                <template #right>
                    <AButton
                        v-if="!guide"
                        theme="dark"
                        :text="$t('ui.close')"
                        @onClick="handleCloseClick"
                    >
                        <template #left>
                            <svg-icon
                                original
                                name="icons/close"
                                class="close-icon"
                            />
                        </template>
                    </AButton>
                </template>
            </OWItemsHeader>
        </template>
        <template #main>
            <RecycleScroller
                ref="tilesList"
                #default="{ item }"
                :items="filteredItems"
                :item-size="97"
                class="o-d-care__scroller"
                emitUpdate
                @update="highlightActiveLetter"
            >
                <OWItemTile
                    :item="getDenormalisedObjectById(item.id)"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TItems>
</template>

<script>
import uniq from "lodash/uniq";

import { mapGetters } from 'vuex';

import TItems from '../../templates/t-items/t-items';
import AButton from '../../atoms/a-button/a-button';
import OWItemTile from '../../organisms/o-w-item-tile/o-w-item-tile';
import OWItemsHeader from '../../organisms/o-w-items-header/o-w-items-header';

import webItemFunctionality from '../../../utils/mixins/web-items-functionality';
import firstElementTabNavigation from '../../../utils/mixins/first-element-tab-navigations';

export default {
    name: 'ODCare',
    components: {
        TItems,
        OWItemTile,
        AButton,
        OWItemsHeader
    },
    data() {
        return {
            filteredByLetter: null,
            currentLetterIndexPanel: 'a',
            tabNavigationStartElement: '.o-w-item-tile',
            scrollerItemsNumber: 0 // This variable shows us how many items be in RecycleScroller
        }
    },
    mixins: [
        webItemFunctionality,
        firstElementTabNavigation
    ],
    props: {
        guide: {
            type: Boolean,
            default: false
        },
        filteredByItem: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getTenantsAZ',
            'getDenormalisedObjectById'
        ]),
        filteredItems() {
            if(this.filteredByItem) {
                return this.getTenantsAZ.filter(item => item.id !== this.filteredByItem)
            } else {
                return this.getTenantsAZ
            }
        },
        activeIndexButtons() {
            return uniq(this.getTenantsAZ.map((item) => {
                return this.t(item, "name").charAt(0).toLowerCase();
            }));
        }
    },
    mounted() {
        this.scrollerItemsNumber = Math.ceil( document.querySelector('.o-d-care__scroller').clientHeight / 97) + 5;
        this.currentLetterIndexPanel = this.t(this.filteredItems[0], 'name').charAt(0).toLowerCase();
    },
    methods: {
        handleTileClick(data) {
            if (this.guide) {
                this.$emit('onTileClick', data);
            } else {
                const params = {
                    name: 'web.guide',
                    params: {
                        type: 'care'
                    },
                    query: {
                        to: data.id
                    }
                };
                this.$router.push(params);
            }
        },
        highlightActiveLetter(start, end) {
            const item = this.filteredItems[start + 3];
            if(end < this.filteredItems.length && end > this.scrollerItemsNumber) 
                this.currentLetterIndexPanel = this.t(item, 'name').charAt(0).toLowerCase();
        },
        handleLetterClick(letter) {
            const itemIndex = this.filteredItems.findIndex( i  => this.t(i,'name',' ').charAt(0).toLowerCase() === letter);
            if(itemIndex !== -1)
                this.$refs.tilesList.scrollToItem(itemIndex)
        }
    }
}
</script>

<style lang="scss">
@import "o-d-care";
</style>
